import { useParams } from 'react-router'
import { useGetCLientQuery } from 'src/redux/Api/clientsApi'
import BackBtn from 'src/Components/BackBtn'
import Loader from 'src/Components/Loader'
import { ClientInfo } from '../components/ClientInfo'

export const Client = () => {
  const { id } = useParams()
  if (!id) return null

  const { data, isLoading } = useGetCLientQuery(id)

  return (
    <>
      <h1>
        <BackBtn />
        Client Profile
      </h1>
      <section>
        {isLoading ? (
          <Loader height={50} />
        ) : data && data.id ? (
          <ClientInfo data={data} />
        ) : (
          <div>Client not found</div>
        )}
      </section>
    </>
  )
}
